export const FIRM_INFO = {
  name: 'Cohen, Tucker & Ades, P.C.',
  phone: '+12128400050',
  displayPhone: '+1 (212) 840-0050',
  email: 'info@cohentuckerlaw.com',
  address: '42 Broadway, Suite 310, New York, NY',
  blogUrl: 'https://cohentuckerlaw.com/blog',
};

export const LEGAL_DISCLAIMER =
  'This tool provides general information only and does not constitute legal advice or create an attorney-client relationship.';
